(function (app) {
    app.constant("relationTypes",
    [
        { Name: "Client", DisplayName: "Client", IsViewable: false},
        { Name: "Spouse", DisplayName: "Spouse", IsViewable: true },
        { Name: "Sibling", DisplayName: "Sibling", IsViewable: true },
        { Name: "Parent", DisplayName: "Parent", IsViewable: true },
        { Name: "Child", DisplayName: "Child", IsViewable: true },
        { Name: "Other", DisplayName: "Other", IsViewable: true },
        { Name: "Grandparent", DisplayName: "Grandparent", IsViewable: true },
        { Name: "Grandchild", DisplayName: "Grandchild", IsViewable: true },
        { Name: "SiblingChild", DisplayName: "Sibling Child", IsViewable: true },
        { Name: "ParentSibling", DisplayName: "Parent Sibling", IsViewable: true },
        { Name: "Trust", DisplayName: "Trust", IsViewable: true }
    ]);
})(window.app); //jshint ignore:line